import { useEffect } from "react";
import "../App.css";
import "../App.tailwind.css";
function PasswordModificationPage() {
    useEffect(() => {
        // Password management is handled by Keycloak
        window.location.href = "/ConnectionPage";
    }, []);
    return null;
}
export default PasswordModificationPage;
